goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Misuse$default");
shadow.js.shim.module$$carbon$icons_react$es$Misuse$default = shadow.js.require(367, {}).default;
